/**
 * @generated SignedSource<<28561e028e5dbccfb54cbc04405b87ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LoginWithSnsIdMutationInput = {
  clientMutationId?: string | null;
  email: string;
  id: string;
  password: string;
  snsId: string;
  snsType: string;
};
export type AuthSnsSignupLoginMutation$variables = {
  input: LoginWithSnsIdMutationInput;
};
export type AuthSnsSignupLoginMutation$data = {
  readonly loginWithSnsId: {
    readonly __typename: "LoginWithSnsIdError";
    readonly message: string;
  } | {
    readonly __typename: "LoginWithSnsIdToken";
    readonly refreshToken: string;
    readonly token: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type AuthSnsSignupLoginMutation = {
  response: AuthSnsSignupLoginMutation$data;
  variables: AuthSnsSignupLoginMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "loginWithSnsId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "token",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "refreshToken",
            "storageKey": null
          }
        ],
        "type": "LoginWithSnsIdToken",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "type": "LoginWithSnsIdError",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthSnsSignupLoginMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AuthSnsSignupLoginMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "26e8627e05b48ba27b993824e408caa1",
    "id": null,
    "metadata": {},
    "name": "AuthSnsSignupLoginMutation",
    "operationKind": "mutation",
    "text": "mutation AuthSnsSignupLoginMutation(\n  $input: LoginWithSnsIdMutationInput!\n) {\n  loginWithSnsId(input: $input) {\n    __typename\n    ... on LoginWithSnsIdToken {\n      token\n      refreshToken\n    }\n    ... on LoginWithSnsIdError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "868d8b5a13e686e4af7d67908c23b476";

export default node;
